import { IMatrixModel } from "./IMatrixModel.intf";


export const matrixModel:IMatrixModel = {
    matrixConf:{
        homeserver:""
    }
}
